import baseService from './baseService';

export default {
  aprovarRejeitar(itemLista) {
    return baseService.post('regularidade/aprovarRejeitar', itemLista);
  },

  // Novo método adicionado
  getDocumentosRegularidade(idFornecSolicitacao) {
  return baseService.get(`regularidade/documentos?idFornecSolicitacao=${idFornecSolicitacao}`);
  }
  ,
  calcularData(payload) {
    return baseService.post('regularidade/calcular-data', payload);
  }
};
